/* unplugin-vue-components disabled */import script from "./IntegralHotelDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./IntegralHotelDetails.vue?vue&type=script&setup=true&lang=js"

import "./IntegralHotelDetails.vue?vue&type=style&index=0&id=2f8f2dfb&lang=scss"

const __exports__ = script;

export default __exports__